<template>
  <div class="page">
    <div class="page-title">Customer Orders</div>
    <div class="page-content">
      <loading-panel :loading="loading" class="w-100">
        <div class="table table-hover table-striped table-thick w-100">
          <v-data-table class="w-100" :headers="headers" :items="orders">
            <template v-slot:item.id="{ item }">{{
              item.id + $consts.ORDER_NUM_BASE
            }}</template>
            <template v-slot:item.price="{ item }"
              >${{ item.price.toFixed(2) }}</template
            >
            <template v-slot:item.user="{ item }"
              >{{ item.user.firstName }} {{ item.user.lastName }}</template
            >
            <template v-slot:item.updatedAt="{ item }">
              <a :href="`/#/customer-orders/${item.id}`">
                <button class="btn small-btn">
                  <i class="fa fa-search-dollar"></i> View
                </button>
              </a>
            </template>
            <template v-slot:item.handled="{ item }">
              <i :class="`fa ${item.handled ? 'fa-check' : 'fa-times'}`"></i>
            </template>
            <template v-slot:item.stripePurchaseIntent="{ item }">
              <a
                target="_blank"
                :href="`https://dashboard.stripe.com/test/payments/${item.stripePurchaseIntent}`"
                ><button class="btn small-btn">
                  <i class="fab fa-2x fa-stripe"></i></button
              ></a>
            </template>
          </v-data-table>
        </div>
        <error-panel class="m-auto text-center" :errors="errors"></error-panel>
      </loading-panel>
    </div>
  </div>
</template>

<script>
import consts from "@/consts.ts";

export default {
  name: "companies",
  components: {},
  data: () => ({
    loading: false,
    headers: [
      { text: "Confirmation #", align: "center", value: "id" },
      { text: "Date", align: "center", value: "createdAt" },
      { text: "Placed By (User)", align: "center", value: "user" },
      { text: "Price", align: "center", value: "price" },
      { text: "Status", align: "center", value: "handled" },
      { text: "", align: "center", value: "updatedAt", sortable: false },
      {
        text: "",
        align: "center",
        value: "stripePurchaseIntent",
        sortable: false,
      },
    ],
    orders: [],
    errors: [],
  }),
  methods: {},
  async mounted() {
    try {
      this.loading = true;
      const response = await this.$web.getCustomerOrders();
      if (response.data.orders && response.data.orders.length > 0) {
        this.orders = response.data.orders;
      } else {
        this.errors = ["No orders found."];
      }
    } catch (err) {
      console.log(err);
      this.errors = ["An error occurred."];
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.customer-orders {
  padding: 20px;
  max-width: 768px;
}

.table {
  display: flex;
  justify-content: center;
}

tr {
  padding: 20px !important;
}

.status {
  color: green;
}
</style>
